import { render, staticRenderFns } from "./FormHistory.vue?vue&type=template&id=65cb3980&scoped=true&"
import script from "./FormHistory.vue?vue&type=script&lang=js&"
export * from "./FormHistory.vue?vue&type=script&lang=js&"
import style0 from "./FormHistory.vue?vue&type=style&index=0&id=65cb3980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cb3980",
  null
  
)

export default component.exports